module.exports = __webpack_public_path__ + "static/media/random-code.0717d2d9.mp4";